import React, {
  Fragment,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import Grid from "@mui/material/Grid";
import ButtonMui from "@mui/material/Button";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import SearchIcon from "@mui/icons-material/Search";
import SyncIcon from "@mui/icons-material/Sync";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Tag } from "primereact/tag";
import { Toast } from "primereact/toast";
import { ProgressBar } from "primereact/progressbar";
import Menu from "./Menu";
import Spinner from "./Spinner";
import { AlertContext } from "../../context/AlertContext";
import { AuthContext } from "../../context/AuthContext";
import { ConfiguracionContext } from "../../context/ConfiguracionContext";
import { useNavigate } from "react-router-dom";
import clienteAxios from "../../config/axios";
import { saveAs } from "file-saver";

import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../../assets/css/DataTableDemo.css";

export default function RendicionesDebitosAutomaticos() {
  const toast = useRef(null);
  const inputFileRef = useRef(null);
  const [progresoIdentificacion, setProgresoIdentificacion] = useState(0);
  let navigate = useNavigate();

  const formatos = [
    { label: "Master - DA168D", value: "master-da168d" },
    { label: "Visa - DEBLIQC", value: "visa-debliqc" },
    { label: "Master Nuevo - DEBLIMC", value: "master-deblimc" },
    { label: "Cabal - COM", value: "cabal-com" },
  ];

  const [archivo, setArchivo] = useState(null);
  const [formato, setFormato] = useState(null);
  const [movimientos, setMovimientos] = useState([]);
  const [identificados, setIdentificados] = useState([]);
  const [pendientes, setPendientes] = useState([]);

  const [globalFilter, setGlobalFilter] = useState("");
  const [procesando, setProcesando] = useState(false);
  const [aceptados, setAceptados] = useState([]);
  const [rechazados, setRechazados] = useState([]);
  const [cuentaSeleccionada, setCuentaSeleccionada] = useState([]);

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const { statusAcceso, cuentas, obtenerAcceso, obtenerCuentas } =
    configuracionContext;

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "RendicionesEspeciales",
      });
    }
  }, [state.id]);

  useEffect(() => {
    obtenerCuentas();
  }, []);

  const resumen = useMemo(() => {
    return movimientos.reduce(
      (acc, item) => {
        acc.cantidad += 1;
        acc.total += Number(item.importe || 0);
        return acc;
      },
      { cantidad: 0, total: 0 },
    );
  }, [movimientos]);

  const exitClick = () => {
    navigate("/");
  };

  const soloNumeros = (valor) =>
    valor === null || valor === undefined
      ? ""
      : valor.toString().replace(/\D/g, "");

  const normalizarNumero = (valor) => {
    if (valor === null || valor === undefined || valor === "") return 0;

    if (typeof valor === "number") return valor;

    let texto = valor.toString().trim().replace(/[^\d,.-]/g, "");

    if (texto.includes(",") && texto.includes(".")) {
      texto = texto.replace(/\./g, "").replace(",", ".");
    } else if (texto.includes(",")) {
      texto = texto.replace(",", ".");
    }

    return Number(texto);
  };

  const importeDesdeCentavos = (valor) => Number(valor || 0) / 100;

  const obtenerPartesTarjetaEnmascarada = (valor) => {
    const texto = valor ? valor.toString().replace(/"/g, "").trim() : "";
    const numeros = soloNumeros(texto);
    const esPrimerosUltimos = numeros.length === 10 && !/[xX*]/.test(texto);
    const posicionesVisibles = esPrimerosUltimos
      ? []
      : texto
          .split("")
          .map((caracter, index) =>
            /\d/.test(caracter)
              ? {
                  posicion: index,
                  digito: caracter,
                }
              : null,
          )
          .filter((item) => item);

    return {
      tarjetaArchivo: texto,
      primeros6: numeros.substring(0, 6),
      ultimos4: numeros.substring(Math.max(numeros.length - 4, 0)),
      posicionesVisibles,
      largoTarjetaArchivo: esPrimerosUltimos ? null : texto.length,
      tarjetaCompleta: numeros.length >= 15 && !/[xX*]/.test(texto),
    };
  };

  const normalizarTexto = (valor) =>
    valor === null || valor === undefined ? "" : valor.toString().trim();

  const esEstadoRechazado = (valor) => {
    const texto = normalizarTexto(valor).toUpperCase();

    return (
      texto.includes("RECHAZ") ||
      texto.includes("DENEG") ||
      texto.includes("ERROR") ||
      texto.includes("FALL")
    );
  };

  const buscarCampo = (row, posiblesNombres) => {
    const keys = Object.keys(row);

    for (const nombre of posiblesNombres) {
      const key = keys.find(
        (k) =>
          k.toString().trim().toUpperCase() ===
          nombre.toString().trim().toUpperCase(),
      );

      if (key) return row[key];
    }

    return null;
  };

  const parsearLineaTexto = (linea, index) => {
    const texto = linea || "";
    const limpia = texto.trimEnd();

    if (!limpia.trim()) return null;

    let numeroTarjeta = null;
    let importe = 0;
    let estado = "Leido";
    let mensajeRechazo = "";
    let rechazado = false;

    if (formato === "visa-debliqc" && limpia.startsWith("1")) {
      numeroTarjeta = soloNumeros(limpia.substring(26, 42));
      importe = importeDesdeCentavos(limpia.substring(62, 77));
      const codigoRechazo = limpia.substring(129, 132).trim();
      mensajeRechazo = limpia.substring(132, 159).trim();

      if (codigoRechazo && codigoRechazo !== "000") {
        rechazado = true;
        estado = mensajeRechazo || "Rechazado " + codigoRechazo;
      }
    } else if (formato === "master-deblimc" && limpia.startsWith("1")) {
      numeroTarjeta = soloNumeros(limpia.substring(26, 42));
      importe = importeDesdeCentavos(limpia.substring(62, 77));
      const codigoRechazo = limpia.substring(129, 132).trim();
      mensajeRechazo = limpia.substring(132, 167).trim();

      if (codigoRechazo && codigoRechazo !== "000") {
        rechazado = true;
        estado = mensajeRechazo || "Rechazado " + codigoRechazo;
      }
    } else if (formato === "cabal-com") {
      numeroTarjeta = soloNumeros(limpia.substring(9, 25));
      importe = importeDesdeCentavos(limpia.substring(25, 36));
      const codigoEstado = limpia.substring(115, 117).trim().toUpperCase();

      if (/[A-Z]/.test(codigoEstado)) {
        rechazado = true;
        mensajeRechazo = `Rechazado ${codigoEstado}`;
        estado = mensajeRechazo;
      }
    } else {
      estado = "Ignorado";
    }

    if (!numeroTarjeta || Number(importe) <= 0) return null;

    return {
      id: index + 1,
      linea: index + 1,
      numeroTarjeta,
      ...obtenerPartesTarjetaEnmascarada(numeroTarjeta),
      importe: Number(importe),
      referencia: "",
      saldoAfiliados: 0,
      diferencia: 0,
      afiliados: [],
      estado,
      rechazado,
      mensajeRechazo,
      detalle: limpia,
    };
  };

  const parsearRow = (row, index) => {
    let numeroTarjeta = soloNumeros(
      buscarCampo(row, [
        "Tarjeta",
        "Numero Tarjeta",
        "Numero",
        "Nro Tarjeta",
        "Nro. Tarjeta",
        "Card Number",
      ]),
    );

    const referencia = soloNumeros(buscarCampo(row, ["Referencia"]) || "");

    let importe = normalizarNumero(
      buscarCampo(row, [
        "Importe",
        "Monto",
        "Total",
        "Valor",
        "Amount",
        "Importe Neto",
      ]),
    );

    if (formato === "master-da168d") {
      const tarjetaOriginal = buscarCampo(row, ["Tarjeta"]) || "";
      const partesTarjeta = obtenerPartesTarjetaEnmascarada(tarjetaOriginal);

      numeroTarjeta = partesTarjeta.tarjetaArchivo;
      importe = normalizarNumero(buscarCampo(row, ["Importe"]));
    }

    const estadoArchivo = normalizarTexto(
      buscarCampo(row, [
        "Estado",
        "Estado Transaccion",
        "Estado Transacción",
        "Estado de Transaccion",
        "Estado de Transacción",
        "Resultado",
        "Status",
      ]) || "Leido",
    );
    const mensajeRechazo = normalizarTexto(
      buscarCampo(row, [
        "Motivo",
        "Motivo Rechazo",
        "Motivo de Rechazo",
        "Descripcion",
        "Descripción",
        "Observacion",
        "Observación",
        "Detalle Rechazo",
        "Mensaje",
      ]),
    );
    const rechazado = esEstadoRechazado(estadoArchivo);

    if (!numeroTarjeta || Number(importe) <= 0) return null;

    return {
      id: index + 1,
      linea: index + 1,
      numeroTarjeta,
      ...obtenerPartesTarjetaEnmascarada(numeroTarjeta),
      importe: Number(importe),
      referencia,
      saldoAfiliados: 0,
      diferencia: 0,
      afiliados: [],
      estado: "Leido",
      estadoArchivo,
      rechazado,
      mensajeRechazo,
      motivoRechazo: mensajeRechazo,
      detalle: JSON.stringify(row),
    };
  };

  const claveMovimientoTarjeta = (mov) => {
    if (mov.tarjetaCompleta !== false) {
      return `completa-${soloNumeros(mov.numeroTarjeta)}`;
    }

    return `visible-${mov.tarjetaArchivo || mov.numeroTarjeta}`;
  };

  const agruparMovimientosPorTarjeta = (items) => {
    const grupos = new Map();

    items.forEach((mov) => {
      const clave = claveMovimientoTarjeta(mov);
      const existente = grupos.get(clave);

      if (!existente) {
        grupos.set(clave, {
          ...mov,
          importe: Number(mov.importe || 0),
          lineas: [mov.linea],
          referencias: mov.referencia ? [mov.referencia] : [],
          cantidadMovimientos: 1,
        });
        return;
      }

      grupos.set(clave, {
        ...existente,
        rechazado: existente.rechazado || mov.rechazado,
        mensajeRechazo: existente.mensajeRechazo || mov.mensajeRechazo,
        motivoRechazo: existente.motivoRechazo || mov.motivoRechazo,
        estado:
          existente.rechazado || mov.rechazado
            ? existente.mensajeRechazo || mov.mensajeRechazo || "Rechazado"
            : existente.estado,
        importe: Number(
          (Number(existente.importe || 0) + Number(mov.importe || 0)).toFixed(2),
        ),
        lineas: [...(existente.lineas || []), mov.linea],
        referencias: mov.referencia
          ? [...(existente.referencias || []), mov.referencia]
          : existente.referencias || [],
        referencia: [
          ...(existente.referencias || []),
          ...(mov.referencia ? [mov.referencia] : []),
        ].join(" / "),
        detalle: `${existente.detalle || ""}\n${mov.detalle || ""}`,
        cantidadMovimientos: Number(existente.cantidadMovimientos || 1) + 1,
      });
    });

    return Array.from(grupos.values()).map((mov, index) => ({
      ...mov,
      id: index + 1,
    }));
  };

  const leerArchivo = async () => {
    if (!archivo) {
      mensajeAlerta("Tarjetas", "Debe seleccionar un archivo.", "error");
      return;
    }

    if (!formato) {
      mensajeAlerta("Tarjetas", "Debe seleccionar un formato.", "error");
      return;
    }

    setProcesando(true);

    try {
      const nombre = archivo.name.toLowerCase();
      let movimientosArchivo = [];

      if (
        nombre.endsWith(".xls") ||
        nombre.endsWith(".xlsx") ||
        nombre.endsWith(".csv")
      ) {
        const xlsx = await import("xlsx");
        let workbook = null;

        if (nombre.endsWith(".csv")) {
          const text = await archivo.text();
          const primeraLinea = text.split(/\r?\n/).find((linea) => linea.trim());
          const separadorCsv =
            primeraLinea &&
            primeraLinea.split(";").length > primeraLinea.split(",").length
              ? ";"
              : ",";

          workbook = xlsx.read(text, {
            type: "string",
            raw: true,
            FS: separadorCsv,
          });
        } else {
          const data = await archivo.arrayBuffer();
          workbook = xlsx.read(data, {
            type: "array",
          });
        }

        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const rows = xlsx.utils.sheet_to_json(sheet, { defval: "" });

        movimientosArchivo = rows
          .map((row, index) => parsearRow(row, index))
          .filter((item) => item);
      } else {
        const text = await archivo.text();

        movimientosArchivo = text
          .split(/\r?\n/)
          .map((linea, index) => parsearLineaTexto(linea, index))
          .filter((item) => item);
      }

      const movimientosAgrupados =
        agruparMovimientosPorTarjeta(movimientosArchivo);

      setMovimientos(movimientosAgrupados);

      mensajeAlerta(
        "Tarjetas",
        `Se leyeron ${movimientosArchivo.length} movimientos y quedaron ${movimientosAgrupados.length} tarjetas.`,
        "success",
      );
    } catch (error) {
      console.log(error);
      mensajeAlerta("Tarjetas", "Error leyendo el archivo.", "error");
    } finally {
      setProcesando(false);
    }
  };

  const identificarTarjetas = async () => {

    if (!formato) {
      mensajeAlerta("Tarjetas", "Debe seleccionar un formato.", "error");
      return;
    }

    if (!movimientos || movimientos.length === 0) {
      mensajeAlerta("Tarjetas", "No hay movimientos para procesar.", "error");
      return;
    }

    setProcesando(true);
    setProgresoIdentificacion(10);

    let intervalo = setInterval(() => {
      setProgresoIdentificacion((prev) => {
        if (prev >= 90) return prev;
        return prev + 5;
      });
    }, 800);

    try {
      const respuesta = await clienteAxios.post(
        "/api/configuracion/identificartarjetas",
        {
          formato,
          movimientos,
        },
      );

      clearInterval(intervalo);
      setProgresoIdentificacion(100);

      const resultado = respuesta.data.resultado || [];
      const aplicarCantidadAfiliados = (items) =>
        items.map((item) => ({
          ...item,
          cantidadMovimientos:
            item.cantidadAfiliados !== undefined
              ? item.cantidadAfiliados
              : item.cantidadMovimientos,
        }));
      const identificados = aplicarCantidadAfiliados(
        respuesta.data.identificados || [],
      );
      const pendientes = aplicarCantidadAfiliados(
        respuesta.data.pendientes || [],
      );

      setMovimientos([...identificados, ...pendientes]);

      setIdentificados(identificados);
      setPendientes(pendientes);

      mensajeAlerta("Banco", "Movimientos identificados.", "success");
    } catch (error) {
      clearInterval(intervalo);
      console.log(error);
      mensajeAlerta(
        "Banco",
        error.response?.data || "Error identificando socios.",
        "error",
      );
    } finally {
      setTimeout(() => {
        setProgresoIdentificacion(0);
        setProcesando(false);
      }, 800);
    }
  };

  const procesarTarjetas = async () => {
    if (!cuentaSeleccionada || cuentaSeleccionada.length === 0) {
      mensajeAlerta("Tarjetas", "Debe seleccionar una cuenta.", "error");
      return;
    }

    if (!identificados || identificados.length === 0) {
      mensajeAlerta("Tarjetas", "No hay movimientos para procesar.", "error");
      return;
    }

    setProcesando(true);

    try {
      const respuesta = await clienteAxios.post(
        "/api/configuracion/procesartarjetas",
        {
          identificados,
          pendientes,
          cuentaSeleccionada,
          usuario: state.usuario,
        },
      );

      let data1 = respuesta.data.aceptados;
      let data2 = respuesta.data.rechazados;

      setAceptados(data1);
      setRechazados(data2);

      let elem = document.getElementById("listadoTarjetas");
      if (elem) {
        setTimeout(() => {
          elem.click();
        }, 500);
      }

      mensajeAlerta("Tarjetas", "Procesando identificados.", "success");
    } catch (error) {
      console.log(error);
      mensajeAlerta(
        "Tarjetas",
        error.response?.data || "Error Procesando socios.",
        "error",
      );
    } finally {
      setProcesando(false);
    }
  };

  const estadoBody = (rowData) => {
    if (rowData.estado === "Identificado") {
      return <Tag severity="success" value="Identificado" />;
    }
    if (rowData.estado === "Leido") {
      return <Tag severity="info" value="Leido" />;
    }
    if (["ACEPTADO", "APROBADO"].includes(normalizarTexto(rowData.estado).toUpperCase())) {
      return <Tag severity="success" value={rowData.estado} />;
    }
    if (rowData.estado === "Diferencia Importe") {
      return <Tag severity="warning" value="Diferencia Importe" />;
    }
    return <Tag severity="danger" value={rowData.estado || "Pendiente"} />;
  };

  const tarjetaBody = (rowData) => {
    return (
      <div>
        <div>{rowData.numeroTarjeta}</div>
        {rowData.tarjetaCompleta === false ? (
          <Tag
            severity="warning"
            value={`Enmascarada ${rowData.primeros6 || ""}...${
              rowData.ultimos4 || ""
            }`}
          />
        ) : null}
      </div>
    );
  };

  const importeBody = (rowData) => {
    return Number(rowData.importe || 0).toLocaleString("es-AR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const saldoBody = (rowData) => {
    return Number(rowData.saldoAfiliados || 0).toLocaleString("es-AR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const diferenciaBody = (rowData) => {
    return Number(rowData.diferencia || 0).toLocaleString("es-AR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const afiliadosBody = (rowData) => {
    if (!rowData.afiliados || rowData.afiliados.length === 0) return "";

    return rowData.afiliados
      .map((item) => `${item.id_titular || ""} ${item.nombre_razonsocial || ""}`)
      .join(" / ");
  };

  const header = (
    <div className="table-header">
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          value={globalFilter}
          onChange={(e) => setGlobalFilter(e.target.value)}
          placeholder="Buscar"
        />
      </span>
    </div>
  );


  const exportExcelAceptados = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(aceptados);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(
        excelBuffer,
        "Aceptados-Tarjetas-" + formato,
      );
    });
  };

  const exportExcelRechazados = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(rechazados);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(
        excelBuffer,
        "Rechazados-Tarjetas-" + formato,
      );
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      return new Promise((resolve) => {
        saveAs(
          data,
          fileName + "-" + new Date().toLocaleDateString() + EXCEL_EXTENSION,
        );
        resolve(true);
      });
    });
  };


  const accesoDenegado = () => {
    mensajeAlerta(
      "Rendiciones Tarjetas",
      "No tiene permiso para acceder a esta pantalla !.",
      "error",
    );
    exitClick();
    return;
  };


  //console.log(formato)



  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Fragment>
          <Grid container spacing={2} style={{ padding: "1rem" }}>
            <Grid item xs={12}>
              <h2>Rendiciones de Debitos Automaticos</h2>
            </Grid>

            <Grid item xs={12} md={4}>
              <input
                ref={inputFileRef}
                type="file"
                accept=".txt,.csv,.xls,.xlsx"
                style={{ display: "none" }}
                onChange={(e) => {
                  if (e.target.files && e.target.files.length > 0) {
                    setArchivo(e.target.files[0]);
                  }
                }}
              />
              <ButtonMui
                variant="contained"
                startIcon={<UploadFileIcon />}
                onClick={() => inputFileRef.current.click()}
                fullWidth
              >
                Seleccionar archivo
              </ButtonMui>
            </Grid>

            <Grid item xs={12} md={4}>
              <ButtonMui
                variant="contained"
                color="primary"
                onClick={leerArchivo}
                fullWidth
                disabled={procesando || !archivo || !formato}
              >
                Leer archivo
              </ButtonMui>
            </Grid>

            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                flexWrap: "wrap",
              }}
            >
              <div>
                {archivo && (
                  <>
                    <b>Archivo:</b> {archivo.name}
                  </>
                )}
              </div>

              <Dropdown
                value={formato}
                options={formatos}
                onChange={(e) => setFormato(e.value)}
                placeholder="Formato"
                showClear
                style={{ width: "240px" }}
              />

              
              <Dropdown
                value={cuentaSeleccionada}
                options={cuentas ? cuentas.filter((item) => item.habilitado) : []}
                onChange={(e) => setCuentaSeleccionada(e.value)}
                placeholder="Seleccione Cuenta"
                optionLabel="nombre"
                showClear
                style={{ width: "250px" }}
              />

              <Tag value={`Registros ${resumen.cantidad}`} />
              <Tag
                severity="danger"
                value={`Total ${resumen.total.toLocaleString("es-AR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`}
              />
            </Grid>

            <Grid item xs={12}>
              <ButtonMui
                variant="contained"
                color="success"
                startIcon={<SearchIcon />}
                onClick={identificarTarjetas}
                disabled={procesando || movimientos.length === 0}
              >
                Identificar tarjetas
              </ButtonMui>

              <ButtonMui
                variant="contained"
                color="warning"
                startIcon={<SyncIcon />}
                onClick={procesarTarjetas}
                disabled={procesando || movimientos.length === 0}
                style={{ marginLeft: "2em" }}
              >
                Procesar Registros Identificados
              </ButtonMui>

              <ButtonMui
                variant="outlined"
                color="secondary"
                onClick={exitClick}
                style={{ marginLeft: "2em" }}
              >
                Volver
              </ButtonMui>

              {procesando && progresoIdentificacion > 0 && (
                <Grid item xs={12} style={{ marginTop: "1rem" }}>
                  <ProgressBar value={progresoIdentificacion} />
                </Grid>
              )}

                            <button
                id="listadoTarjetas"
                type="button"
                onClick={(e) => {
                  exportExcelAceptados();
                  exportExcelRechazados();
                }}
                style={{ display: "none" }}
              >
                Export Excel
              </button>

            </Grid>

            <Grid item xs={12}>
              <DataTable
                value={movimientos}
                paginator
                rows={50}
                rowsPerPageOptions={[20, 50, 100, 500, 1000, 5000]}
                globalFilter={globalFilter}
                header={header}
                responsiveLayout="scroll"
                emptyMessage="No hay movimientos cargados"
              >
                <Column field="linea" header="Linea" sortable />
                <Column
                  field="cantidadMovimientos"
                  header="Movs"
                  sortable
                />
                <Column
                  field="numeroTarjeta"
                  header="Tarjeta"
                  body={tarjetaBody}
                  sortable
                />
                <Column field="referencia" header="Referencia" sortable />
                <Column
                  field="importe"
                  header="Importe Archivo"
                  body={importeBody}
                  sortable
                />
                <Column header="Afiliados" body={afiliadosBody} sortable />
                <Column
                  field="saldoAfiliados"
                  header="Saldo Afiliados"
                  body={saldoBody}
                  sortable
                />
                <Column
                  field="diferencia"
                  header="Diferencia"
                  body={diferenciaBody}
                  sortable
                />
                <Column header="Estado" body={estadoBody} sortable />
              </DataTable>
            </Grid>
          </Grid>
        </Fragment>
      ) : null}
    </Fragment>
  );
}
